import { Notification } from '@/features/Notifications/Notifications.interfaces';
import { filter, findIndex, get, map, pipe, propEq, set } from 'lodash/fp';

export const readAllNotifications = (notifications: Notification[]): Notification[] =>
  map((n) => set('read', true, n), notifications); // setting the read prop to true

export const readSingleNotification = (
  notificationId: string,
  notifications: Notification[],
): Notification[] => {
  const notificationFoundIndex = findIndex(propEq('id', notificationId), notifications); // get index
  const notificationFound = get(notificationFoundIndex, notifications); // get notification
  const updatedNotification = set('read', true, notificationFound); // setting read to true
  return set(notificationFoundIndex, updatedNotification, notifications); // return updated list
};

export const getUnreadNotifications = (notifications: Notification[]) =>
  filter((item: Notification) => !item.read, notifications);

export const getUnreadNotificationIds = (notifications: Notification[]) =>
  pipe(
    getUnreadNotifications, // filter unread notifications
    map((n: Notification) => n.id), // get only notification ids
  )(notifications);

export const getLength = (list = []) => list.length;
